import { defineMessages } from 'react-intl';

export default defineMessages({
  exportDirectlyToPdf: {
    defaultMessage: 'Export to PDF',
    id: 'wxNbf6',
    description: 'Insights > Reports > Actions > Export to PDF button',
  },
  runReport: {
    defaultMessage: 'Run Report',
    id: 'Rq9Whu',
    description: 'Insights > Reports > Actions > Run Report button',
  },
});
